import axios from 'axios';
import { API_URL } from '../utils/ApiLinks';

export const getCompanyByPageUrl = async (pageUrl: string) => {
  try {
    const response = await axios.get(`${API_URL}/company/by-pageurl/${pageUrl}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error: any) {
    console.error("Error in getCompanyByPageUrl:", error);
    handleAuthError(error);
    return undefined;
  }
};

const handleAuthError = (error: any) => {
  if (error.response) {
    throw new Error(error.response.data.message || error.message); 
  } else {
    throw new Error(error.message || 'An unknown error occurred');
  }
};